// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5w-6";
export var headerCell = "_5w-2";
export var rowWrapper = "_5w-4";
export var stickyAggregationCell = "_5w-a";
export var stickyAggregationRow = "_5w-7";
export var stickyColumnCell = "_5w-9";
export var stickyColumnHeaderCell = "_5w-8";
export var table = "_5w-1";
export var virtualRowWrapper = "_5w-5";
export var virtualTableContainer = "_5w-0";
export var white = "_5w-3";